var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isLoading,
          expression: "isLoading"
        }
      ],
      staticClass: "loadingBox"
    },
    [
      _c(
        "div",
        {
          staticClass: "maxLoading",
          style: { backgroundColor: _vm.backgroundColor }
        },
        [_vm._m(0)]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading_bg" }, [
      _c("div", { staticClass: "loader-inner pacman" }, [
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a26ea77", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a26ea77","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Cc-Loading/loading.vue
// module id = Xo1P
// module chunks = 0 1 2 3 4 5